function chunkArray<T>(arr: T[], size: number): T[][] {
  return arr.reduce((acc: T[][], el, idx) => {
    idx % size ? acc[acc.length - 1].push(el) : acc.push([el]);
    return acc;
  }, []);
}

export default chunkArray;
